import React, { useEffect, useRef, useState } from "react";
import Barcode from "react-barcode";
import ReactToPrint from "react-to-print";
import { useLazyQuery } from "@apollo/client";
import _ from "lodash";
import { Button, Form, Modal, Table } from "react-bootstrap";
import PrintIcon from "@mui/icons-material/Print";

import CustomButton from "../../../components/CustomButton";
import AnimationLoading from "../../../components/Animationloading";
import PaginationHelper from "../../../components/PaginationHelper";
import EmptyComponent from "../../../components/EmptyComponent";
import { convertCurrency, numberFormat } from "../../../helper";
import { errorSwal } from "../../../helper/sweetalert";
import { LINEAR_GRADIENT_BG, USER_KEY } from "../../../const";
import { GET_PRODUCT_VARIANTS } from "../../../apollo/productVariant/query";
import { GET_BRANDS } from "../../../apollo/brand/Query";
import { GET_CATEGORYS } from "../../../apollo/category/query";

const formatAttributes = (attributeValues = []) => {
  if (!Array.isArray(attributeValues) || attributeValues.length === 0) return "";
  return attributeValues
    .map((attr) => {
      const name = attr?.attribute?.name || "";
      const value = attr?.value || "";
      return name ? `${name}${value ? `: ${value}` : ""}` : value;
    })
    .filter(Boolean)
    .join(", ");
};

const getVariantName = (variant) => {
  const productName = variant?.product?.name ?? "-";
  const attrs = formatAttributes(variant?.attributeValues);
  return attrs ? `${productName} (${attrs})` : productName;
};

export default function BarcodeProductVariant() {
  const shopId = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
  const currentCategory = localStorage.getItem("CURRENT_CATEGORY");
  const currentBrand = localStorage.getItem("CURRENT_BRAND");
  const [variants, setVariants] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [barcodeMulti, setBarcodeMulti] = useState();
  const [showbarcodeMulti, setShowBarcodeMulti] = useState(false);
  const [brand, setBrand] = useState();
  const [category, setCategory] = useState();
  const [variantTotal, setVariantTotal] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [searchBrand, setSearchBrand] = useState();
  const [searchCategory, setSearchCategory] = useState();
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [selectedOption, setSelectedOption] = useState("option1");
  const [isPrice, setIsPrice] = useState(true);
  const ref = useRef();

  const [pageNumber, setPageNumber] = useState(1);
  const { _limit, _skip, Pagination_helper } = PaginationHelper();

  const [loadVariants, { data: variantsData, loading }] = useLazyQuery(
    GET_PRODUCT_VARIANTS,
    { fetchPolicy: "cache-and-network" },
  );

  const [LoadBrand, { data: GetBrandData }] = useLazyQuery(GET_BRANDS, {
    fetchPolicy: "network-only",
  });

  const [LoadCategory, { data: GetCategoryData }] = useLazyQuery(
    GET_CATEGORYS,
    { fetchPolicy: "network-only" },
  );

  const handleInputChange = (event) => {
    setSelectedOption(event.target.value);
  };

  useEffect(() => {
    if (currentCategory) setSearchCategory(currentCategory);
    if (currentBrand) setSearchBrand(currentBrand);
  }, [currentCategory, currentBrand]);

  useEffect(() => {
    if (variantsData) {
      let filteredData = variantsData?.productVariants?.data || [];
      if (!_.isEmpty(searchText)) {
        const text = searchText.toLowerCase();
        filteredData = filteredData.filter((item) => {
          const name = item?.product?.name?.toLowerCase() || "";
          const code = item?.barCode?.toLowerCase() || "";
          return name.includes(text) || code.includes(text);
        });
      }
      if (!_.isEmpty(searchCategory) && searchCategory !== "ALL") {
        filteredData = filteredData.filter(
          (item) => item?.product?.category?.id === searchCategory,
        );
      }
      if (!_.isEmpty(searchBrand) && searchBrand !== "ALL") {
        const brandName = brand?.find((b) => b?.id === searchBrand)?.name;
        if (brandName) {
          filteredData = filteredData.filter(
            (item) => item?.product?.brandName === brandName,
          );
        }
      }
      setVariants(filteredData);
      setVariantTotal(variantsData?.productVariants?.total || 0);
    }
  }, [variantsData, searchText, searchCategory, searchBrand, brand]);

  useEffect(() => {
    if (GetCategoryData) {
      const result = (GetCategoryData?.categories?.data || []).sort((a, b) =>
        a?.name?.localeCompare(b?.name),
      );
      setCategory(result);
    }
  }, [GetCategoryData]);

  useEffect(() => {
    if (GetBrandData) {
      const result = (GetBrandData?.brands?.data || []).sort((a, b) =>
        a?.name?.localeCompare(b?.name),
      );
      setBrand(result);
    }
  }, [GetBrandData]);

  useEffect(() => {
    _filter();
    filterBrand();
  }, [searchText, searchBrand, searchCategory, pageNumber, _skip]);

  useEffect(() => {
    LoadCategory({
      variables: {
        limit: 800,
        where: {
          shop: shopId,
          isDeleted: false,
        },
      },
    });
    _filter();
  }, []);

  const filterBrand = () => {
    let _where = {
      shop: shopId,
      isDeleted: false,
    };
    if (!_.isEmpty(searchCategory) && searchCategory !== "ALL") {
      _where = { ..._where, category: searchCategory };
    }
    LoadBrand({
      variables: {
        limit: 800,
        where: _where,
      },
    });
  };

  const _filter = async () => {
    try {
      let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
      let _where = {
        shop: shopId,
        isDeleted: false,
      };
      loadVariants({
        variables: {
          skip: (_skip - 1) * _limit,
          limit: _limit,
          orderBy: "createdAt_DESC",
          where: _where,
        },
      });
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  const handleShowbarcode = () => {
    setBarcodeMulti(selectedItems);
    setShowBarcodeMulti(true);
  };

  const handleCheckboxChangeCount = (event, index) => {
    const updatedItems = [...selectedItems];
    updatedItems[index].count = parseInt(event.target.value);
    setSelectedItems(updatedItems);
  };

  const barcodeElements = (count, barcode, price, currency, name) =>
    Array.from({ length: count, barcode }, (_, index) => {
      if (selectedOption === "option3") {
        return (
          <div
            style={{
              height: "30mm",
              width: "50mm",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              marginBottom: 3,
            }}>
            <div>
              <div style={{ fontSize: 10 }}>{name}</div>
              {isPrice ? (
                <div style={{ fontSize: 12, lineHeight: "12px" }}>
                  {numberFormat(price)} {convertCurrency(currency)}
                </div>
              ) : (
                <div style={{ fontSize: 12, lineHeight: "12px" }}>
                  .....................
                </div>
              )}
              <Barcode
                key={index}
                value={`${barcode}`}
                format={barcode.length == 13 ? "EAN13" : "CODE128"}
                displayValue={true}
                width={1.5}
                height={32}
                fontSize={10}
                fontWeight="bold"
              />
            </div>
          </div>
        );
      }
      return (
        <div
          className={selectedOption === "option2" ? "col-6" : "col-4"}
          style={{
            height: selectedOption === "option2" ? "25.911mm" : "25.5mm",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          }}>
          <div>
            <div
              style={{
                fontSize: 10,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: 120,
              }}>
              {name}
            </div>
            {isPrice ? (
              <div style={{ fontSize: 10, lineHeight: "12px" }}>
                {numberFormat(price)} {convertCurrency(currency)}
              </div>
            ) : (
              <div style={{ fontSize: 10, lineHeight: "12px" }}>
                .....................
              </div>
            )}
            <Barcode
              key={index}
              value={`${barcode}`}
              format={barcode.length == 13 ? "EAN13" : "CODE128"}
              displayValue={true}
              width={barcode.length == 13 ? 1 : 1.3}
              height={14}
              fontSize={10}
            />
          </div>
        </div>
      );
    });

  const onSelectedAllProducts = async () => {
    if (isSelectAll) {
      setSelectedItems([]);
      setIsSelectAll(false);
    } else {
      let _dataForSelectAll = [];
      for (let i = 0; i < variants.length; i++) {
        if (!_.isEmpty(variants[i]?.barCode)) {
          _dataForSelectAll.push({
            ...variants[i],
            name: getVariantName(variants[i]),
            count: 1,
          });
        }
      }
      setSelectedItems(_dataForSelectAll);
      setIsSelectAll(true);
    }
  };

  const handleCheckboxChange = (event) => {
    if (_.isEmpty(event.barCode)) {
      errorSwal("ບໍ່ມີລະຫັດ ບຣາໂຄດ. ກະລຸນາສ້າງບຣາໂຄດກ່ອນ!");
      return;
    }
    const _check = selectedItems.some((item) => item?.id === event?.id);
    if (_check) {
      const _newSelectedItems = selectedItems.filter(
        (item) => item?.id !== event.id,
      );
      setSelectedItems(_newSelectedItems);
      return;
    }
    const _newSelectedItems = [
      ...selectedItems,
      { ...event, name: getVariantName(event), count: 1 },
    ];
    setSelectedItems(_newSelectedItems);
  };

  return (
    <React.Fragment>
      <div
        style={{
          backgroundColor: "#FFFFFF",
          padding: 25,
        }}>
        <div
          style={{
            height: "60px",
            width: "100%",
            display: "flex",
            alignItems: "center",
            paddingBottom: 10,
          }}>
          <div style={{ width: "100%" }}>
            <Form.Group className="mb-3" controlId="variant-search-input">
              <Form.Label>ຊື່ສິນຄ້າ</Form.Label>
              <Form.Control
                type="text"
                placeholder="ຄົ້ນຫາສິນຄ້າ..."
                onChange={(e) => {
                  setSearchText(e.target.value);
                }}
                value={searchText}
              />
            </Form.Group>
          </div>
          &emsp;
          <div style={{ width: "60%" }}>
            <Form.Group className="mb-3" controlId="variant-category-input">
              <Form.Label>ປະເພດ</Form.Label>
              <Form.Select
                onChange={(e) => {
                  setSearchCategory(e.target.value);
                  localStorage.setItem("CURRENT_CATEGORY", e.target.value);
                  localStorage.removeItem("CURRENT_BRAND");
                  setSearchBrand();
                }}
                value={searchCategory}>
                <option value="ALL">--ເລືອກ--</option>
                {category?.map((categorys) => (
                  <option key={categorys.id} value={categorys?.id}>
                    {categorys?.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </div>
          &emsp;
          <div style={{ width: "60%" }}>
            <Form.Group className="mb-3" controlId="variant-brand-input">
              <Form.Label>ແບຣນ</Form.Label>
              <Form.Select
                onChange={(e) => {
                  setSearchBrand(e.target.value);
                  localStorage.setItem("CURRENT_BRAND", e.target.value);
                }}
                value={searchBrand}>
                <option value="ALL">--ເລືອກ--</option>
                {brand?.map((brands, index) => (
                  <option key={brands + index} value={brands?.id}>
                    {brands?.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </div>
          &emsp;
          <div style={{ width: "40%", paddingTop: 10 }}>
            <CustomButton
              icon={<PrintIcon />}
              title="ປິ້ນບຣາໂຄດ"
              color={"white"}
              width="100%"
              height={45}
              borderRadius={8}
              capacitys={selectedItems?.length <= 0 ? "50%" : "100%"}
              onClick={selectedItems?.length <= 0 ? <></> : handleShowbarcode}
            />
          </div>
        </div>
        {loading && !variantsData ? (
          <AnimationLoading />
        ) : (
          <>
            {variants?.length > 0 ? (
              <Table hover responsive>
                <thead
                  style={{
                    background: LINEAR_GRADIENT_BG,
                    borderRadius: " 8px 8px 0px 0px",
                    color: "#FFFFFF",
                    padding: "1em 0",
                  }}>
                  <tr>
                    <th style={{ padding: "1em" }}>
                      <Form.Check
                        aria-label="option 1"
                        style={{ cursor: "pointer" }}
                        checked={isSelectAll}
                        onChange={() => onSelectedAllProducts()}
                        label="ເລືອກ"
                        id="variant-select-all"
                      />
                    </th>
                    <th style={{ padding: "1em" }}>ຊື່ສິນຄ້າ</th>
                    <th style={{ padding: "1em" }}>ຕົວເລືອກ</th>
                    <th style={{ padding: "1em" }}>ລະຫັດບາໂຄດ</th>
                    <th style={{ padding: "1em" }}>ປະເພດສິນຄ້າ</th>
                    <th style={{ padding: "1em" }}>ເເບຣນ</th>
                    <th style={{ padding: "1em" }}>ຈຳນວນສິນຄ້າ</th>
                    <th style={{ padding: "1em" }}>ລາຄາສິນຄ້າ</th>
                  </tr>
                </thead>
                <tbody>
                  {variants?.map((p, index) => (
                    <tr
                      key={p?.id || index}
                      style={{
                        color: p?.barCode ? "#000" : "#777",
                        userSelect: p?.barCode ? "" : "none",
                      }}>
                      <td style={{ padding: "1em" }}>
                        {isSelectAll ? (
                          <>
                            {p?.barCode ? (
                              <Form.Check
                                aria-label="option 12"
                                value={p?.id}
                                label={index + 1 + _limit * (_skip - 1)}
                                checked
                              />
                            ) : (
                              <Form.Check
                                aria-label="option 12"
                                value={p?.id}
                                label={index + 1 + _limit * (_skip - 1)}
                              />
                            )}
                          </>
                        ) : (
                          <Form.Check
                            style={{ cursor: "pointer" }}
                            aria-label="option 1"
                            value={p?.id}
                            label={index + 1 + _limit * (_skip - 1)}
                            id={index + 1 + _limit * (_skip - 1)}
                            checked={selectedItems.some(
                              (item) => item?.id === p?.id,
                            )}
                            onChange={() => handleCheckboxChange(p)}
                          />
                        )}
                      </td>
                      <td style={{ padding: "1em" }}>
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            width: 230,
                          }}>
                          {p?.product?.name ?? "-"}
                        </div>
                      </td>
                      <td style={{ padding: "1em" }}>
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            width: 230,
                          }}>
                          {formatAttributes(p?.attributeValues) || "-"}
                        </div>
                      </td>
                      <td style={{ padding: "1em" }}>{p?.barCode ?? "-"}</td>
                      <td style={{ padding: "1em" }}>
                        {p?.product?.category?.name ?? "-"}
                      </td>
                      <td style={{ padding: "1em" }}>
                        {p?.product?.brandName ?? "-"}
                      </td>
                      <td style={{ padding: "1em" }}>
                        {numberFormat(p?.amount)}
                      </td>
                      <td style={{ padding: "1em" }}>
                        {numberFormat(p?.price ?? 0)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <div>
                {variants?.length <= 0 && (
                  <div
                    style={{
                      fontSize: "24px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "#6B7280",
                      fontWeight: "400",
                    }}>
                    <EmptyComponent />
                    <p>ຍັງບໍ່ມີສິນຄ້າກະລຸນາໄປເພີ່ມສິນຄ້າໃນສະຕອັກກ່ອນ !!!</p>
                  </div>
                )}
              </div>
            )}

            {variantTotal > 0 ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                }}>
                {variantTotal && (
                  <div className="show">
                    ກຳລັງສະແດງ {50 * _skip - 49}-
                    {50 * _skip > variantTotal ? variantTotal : 50 * _skip} ຈາກ{" "}
                    {variantTotal}
                  </div>
                )}
                <div>{Pagination_helper(variantTotal, "", ``)}</div>
                <div></div>
                <div />
              </div>
            ) : (
              ""
            )}
          </>
        )}
      </div>
      <Modal
        show={showbarcodeMulti}
        onHide={() => {
          setShowBarcodeMulti(false);
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        keyboard={false}
        centered>
        <Modal.Header closeButton>
          <Modal.Title>
            ລາຍການພິມບາຮໂຄ້ດ({barcodeMulti?.length} ລາຍການ)
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: 10 }}>
          <div style={{ display: "flex", paddingBottom: "10px" }}>
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                fontSize: 18,
              }}>
              <div>ຂະໜາດເຈ້ຍພິມ</div>
              <div style={{ display: "flex", gap: 5 }}>
                <div style={{ marginLeft: 20 }}>
                  <label>
                    <input
                      type="radio"
                      name="choice"
                      value="option3"
                      checked={selectedOption === "option3"}
                      onChange={handleInputChange}
                      style={{ transform: "scale(2.0)" }}
                    />
                    &emsp;1ດວງ
                  </label>
                </div>
                <div style={{ marginLeft: 20 }}>
                  <label>
                    <input
                      type="radio"
                      name="choice"
                      value="option2"
                      checked={selectedOption === "option2"}
                      onChange={handleInputChange}
                      style={{ transform: "scale(2.0)" }}
                    />
                    &emsp;2ດວງ
                  </label>
                </div>
                <div style={{ marginLeft: 20 }}>
                  <label>
                    <input
                      type="radio"
                      name="choice"
                      value="option1"
                      checked={selectedOption === "option1"}
                      onChange={handleInputChange}
                      style={{ transform: "scale(2.0)" }}
                    />
                    &emsp;3ດວງ
                  </label>
                </div>
              </div>
            </div>
            <div style={{ width: "50%", display: "flex", justifyContent: "end" }}>
              <Button
                onClick={() => {
                  setShowBarcodeMulti(false);
                  setSelectedItems([]);
                  setBarcodeMulti();
                }}
                variant="outline-secondary">
                ຍົກເລີກ
              </Button>

              &emsp;
              <ReactToPrint
                trigger={() => (
                  <CustomButton
                    background={LINEAR_GRADIENT_BG}
                    width="30%"
                    height={40}
                    title={"ພິມ"}
                    icon={<PrintIcon />}
                    borderRadius="5px"
                  />
                )}
                content={() => ref.current}
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "auto",
            }}>
            <Table hover>
              <thead
                style={{
                  background: "#1F3A60",
                  borderRadius: " 8px 8px 0px 0px",
                  color: "#FFFFFF",
                }}>
                <tr>
                  <th>#</th>
                  <th>ຊື່ສິນຄ້າ</th>
                  <th>ລະຫັດບາໂຄດ</th>
                  <th>ປະເພດສິນຄ້າ</th>
                  <th style={{ width: "15%" }}>ຈຳນວນ</th>
                </tr>
              </thead>
              <tbody>
                {selectedItems?.map((b, Onindex) => (
                  <tr key={b?.id || Onindex}>
                    <td>{Onindex + 1}</td>
                    <td>{b?.name ?? "-"}</td>
                    <td>{b?.barCode ?? "-"}</td>
                    <td>{b?.product?.category?.name ?? "-"}</td>
                    <td>
                      <Form.Control
                        min="1"
                        type="number"
                        onChange={(e) => handleCheckboxChangeCount(e, Onindex)}
                        name="count"
                        value={b?.count}
                        placeholder="ຈຳນວນ..."
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}>
            <div style={{ fontSize: 20, fontWeight: "600" }}>
              ຮູບເເບບຕົວຢ່າງ Barcode
            </div>
            <div style={{ padding: "1.5em 0" }}>
              <Form.Check
                type="switch"
                id="variant-price-switch"
                label={!isPrice ? "ສະແດງລາຄາ" : "ບໍ່ສະແດງລາຄາ"}
                name="isPrice"
                onChange={(e) => setIsPrice(e?.target?.checked)}
                checked={isPrice}
              />
            </div>
          </div>

          <div style={{ padding: 20 }}>
            <div
              ref={ref}
              className={selectedOption === "option3" ? "" : "row"}
              style={{
                paddingLeft: selectedOption === "option3" ? 0 : "15px",
                paddingRight: selectedOption === "option3" ? 0 : "15px",
              }}>
              {selectedItems?.map(
                ({ barCode, count, price, currency, name }, index) => {
                  return barcodeElements(count, barCode, price, currency, name);
                },
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
